import { /* CHART_GRAPE  ,  CHART_CANARY, */  CHART_GRAPE /*, CHART_ROYAL */ } from 'constants/colorsDarkMode'
//import source1 from 'assets/ss1.png'
//import source1Light from 'assets/ss1Light.png'
// import iconRn from 'assets/icon-rn.png'

export type TutorialSteps = {
  labelTag: string
  label: string
  description: string
  imgPath: string
  imgPathLight: string
  type: string
  isVideo: boolean
  colorTag: string
  colorText: string
  background: string
}

import source2 from 'assets/ss1.jpg'
import source2Light from 'assets/ss1Light.jpg'
/*const source3 = require('assets/ss3.png')
const source3Light = require('assets/ss3Light.png') */
/*const source4 = require('assets/ss4.png')
const source4Light = require('assets/ss4.png') */

const tutorialSteps: TutorialSteps[] = [
  {
    labelTag: 'Nueva sección',
    label: 'Conoce la nueva sección de Fondos en Análisis',
    description: 'Consulta la composición de la cartera, analiza su desempeño histórico y evalúa retornos para optimizar tu estrategia.',
    type: '',
    imgPath: source2,
    imgPathLight: source2Light,
    isVideo: false,
    colorTag: CHART_GRAPE,
    colorText: '#101419',
    background:
      'linear-gradient(315deg, rgba(0, 0, 0, 0.00) 0%, rgba(10, 56, 218, 0.00) 55.21%, rgba(112, 0, 255, 0.22) 100%)'

  }
  /*   {
    labelTag: 'nueva funcionalidad',
    label: 'Cambia de instrumento en tu gráfica con un solo click',
    description:
      'Dentro de la sección Gráficas avanzadas podrás ver todas tus listas de seguimiento que tienes en tus espacios de trabajo. También, podrás cambiar de instrumento con un solo click.',
    imgPath: source2,
    imgPathLight: source2Light,
    type: '',
    isVideo: false,
    colorTag: CHART_CANARY,
    background:
       'linear-gradient(315deg, rgba(0, 0, 0, 0.00) 0%, rgba(218, 197, 10, 0.00) 55.21%, rgba(255, 122, 0, 0.22) 100%)'
  },
  {
    labelTag: 'Más herramientas',
    label: 'Ve hasta 8 gráficas en una sola vista',
    description: 'En esta nueva sección esta disponible la opción para ver múltiples gráficas al mismo tiempo. ',
    imgPath: source3,
    imgPathLight: source3Light,
    type: '',
    isVideo: false,
    colorTag: CHART_ROYAL,
    background:
      'linear-gradient(317.05deg, rgba(0, 26, 255, 0) 0%, rgba(0, 26, 255, 0.06) 40%, rgba(46, 242, 242, 0.49) 100%)'
  } */
  /*{
    labelTag: 'selector de columnas',
    label: 'Ahora puedes seleccionar las columnas en tus tablas',
    description: 'Selecciona las columnas que deseas ver para los mercados de deuda y capitales',
    imgPath: source4,
    imgPathLight: source4Light,
    type: '',
    isVideo: false,
    colorTag: CHART_SALMON,
    background:
      'linear-gradient(317.05deg, rgba(218, 10, 10, 0) 0%, rgba(64, 10, 218, 0.06) 40%, rgba(242, 93, 46, 0.49) 100%)'
  }, */
  /* ,
  {
    label: "Imagen 1",
    imgPath:
      "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250&q=80",
    type: ""
  } */
  /* Example Image  {
    label: "Imagen 2",
    imgPath:
      "https://images.unsplash.com/photo-1518732714860-b62714ce0c59?auto=format&fit=crop&w=400&h=250&q=60",
    type: ""
  }, */
  /* Exmple video  {
    label: "Video",
    imgPath: video,
    type: "video/mp4",
    isVideo: true
  }, */
]

export default tutorialSteps
